import { render, staticRenderFns } from "./BaseFormTab.vue?vue&type=template&id=1fef25a2&"
import script from "./BaseFormTab.vue?vue&type=script&lang=js&"
export * from "./BaseFormTab.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormTab.vue?vue&type=style&index=0&id=1fef25a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports